export const NAV_DEBUG_STORAGE_KEY = "navDebugRedirects";
export const REPORT_DEBUG_STORAGE_KEY = "reportDebugEnabled";
export const DETERMINISTIC_ROUTE_STORAGE_KEY = "deterministicClientRoute";
export const CLIENT_NAV_RESOLVER_V1_STORAGE_KEY = "clientNavResolverV1";
export const CLIENT_NAV_GUARD_V1_TRAIN_STORAGE_KEY = "clientNavGuardV1Train";
export const CLIENT_NAV_GUARD_V1_NUTRITION_STORAGE_KEY = "clientNavGuardV1Nutrition";
export const CLIENT_NAV_GUARD_V1_SETTINGS_STORAGE_KEY = "clientNavGuardV1Settings";
export const CLIENT_NAV_GUARD_V1_WORKOUT_STORAGE_KEY = "clientNavGuardV1Workout";
export const CLIENT_NAV_GUARD_V1_EXERCISE_WORKOUT_STORAGE_KEY = "clientNavGuardV1ExerciseWorkout";
export const CLIENT_NAV_GUARD_V1_SECONDARY_STORAGE_KEY = "clientNavGuardV1Secondary";
export const CLIENT_NATIVE_BACK_NAVIGATION_STORAGE_KEY = "clientNativeBackNavigation";
export const CLIENT_SECTION_TAB_SWIPE_NAVIGATION_STORAGE_KEY = "clientSectionTabSwipeNavigation";
// Re-enables the legacy "pull down / scroll up to reveal" lock on the program/analysis
// selector header. Defaults OFF: the selector (and its Edit action) is always shown.
export const CLIENT_PROGRAM_SELECTOR_SCROLL_REVEAL_STORAGE_KEY = "clientProgramSelectorScrollReveal";
export const DEV_CONTROLS_OVERLAY_STORAGE_KEY = "devControlsOverlayEnabled";
// Deprecated alias; kept for backward compatibility with older localStorage state.
export const REQUEST_DEBUG_STORAGE_KEY = "requestDebugRoutes";
export const NAV_DEBUG_FLAGS_CHANGED_EVENT = "nav-debug-flags-changed";

export function readDebugFlag(storageKey: string): boolean {
  if (typeof window === "undefined") return false;
  return localStorage.getItem(storageKey) === "1";
}

export function writeDebugFlag(storageKey: string, enabled: boolean): void {
  if (typeof window === "undefined") return;
  if (enabled) {
    localStorage.setItem(storageKey, "1");
  } else {
    localStorage.removeItem(storageKey);
  }
  window.dispatchEvent(new CustomEvent(NAV_DEBUG_FLAGS_CHANGED_EVENT));
}

export function readReportDebugFlag(): boolean {
  if (typeof window === "undefined") return false;
  return (
    localStorage.getItem(REPORT_DEBUG_STORAGE_KEY) === "1" ||
    localStorage.getItem(REQUEST_DEBUG_STORAGE_KEY) === "1"
  );
}

export function writeReportDebugFlag(enabled: boolean): void {
  if (typeof window === "undefined") return;
  if (enabled) {
    localStorage.setItem(REPORT_DEBUG_STORAGE_KEY, "1");
    // Keep alias in sync until fully removed.
    localStorage.setItem(REQUEST_DEBUG_STORAGE_KEY, "1");
  } else {
    localStorage.removeItem(REPORT_DEBUG_STORAGE_KEY);
    localStorage.removeItem(REQUEST_DEBUG_STORAGE_KEY);
  }
  window.dispatchEvent(new CustomEvent(NAV_DEBUG_FLAGS_CHANGED_EVENT));
}

export function readDevControlsOverlayFlag(): boolean {
  if (typeof window === "undefined") return true;
  return localStorage.getItem(DEV_CONTROLS_OVERLAY_STORAGE_KEY) !== "0";
}

export function writeDevControlsOverlayFlag(enabled: boolean): void {
  if (typeof window === "undefined") return;
  if (enabled) {
    localStorage.setItem(DEV_CONTROLS_OVERLAY_STORAGE_KEY, "1");
  } else {
    localStorage.setItem(DEV_CONTROLS_OVERLAY_STORAGE_KEY, "0");
  }
  window.dispatchEvent(new CustomEvent(NAV_DEBUG_FLAGS_CHANGED_EVENT));
}

export function readDeterministicRouteFlag(): boolean {
  if (typeof window === "undefined") return false;
  return localStorage.getItem(DETERMINISTIC_ROUTE_STORAGE_KEY) === "1";
}

export function writeDeterministicRouteFlag(enabled: boolean): void {
  if (typeof window === "undefined") return;
  if (enabled) {
    localStorage.setItem(DETERMINISTIC_ROUTE_STORAGE_KEY, "1");
  } else {
    localStorage.removeItem(DETERMINISTIC_ROUTE_STORAGE_KEY);
  }
  window.dispatchEvent(new CustomEvent(NAV_DEBUG_FLAGS_CHANGED_EVENT));
}

export function readClientNavResolverV1Flag(): boolean {
  if (typeof window === "undefined") return true;
  return localStorage.getItem(CLIENT_NAV_RESOLVER_V1_STORAGE_KEY) !== "0";
}

export function writeClientNavResolverV1Flag(enabled: boolean): void {
  if (typeof window === "undefined") return;
  if (enabled) {
    localStorage.setItem(CLIENT_NAV_RESOLVER_V1_STORAGE_KEY, "1");
  } else {
    localStorage.setItem(CLIENT_NAV_RESOLVER_V1_STORAGE_KEY, "0");
  }
  window.dispatchEvent(new CustomEvent(NAV_DEBUG_FLAGS_CHANGED_EVENT));
}

export function readClientNavGuardV1TrainFlag(): boolean {
  if (typeof window === "undefined") return false;
  return localStorage.getItem(CLIENT_NAV_GUARD_V1_TRAIN_STORAGE_KEY) === "1";
}

export function writeClientNavGuardV1TrainFlag(enabled: boolean): void {
  if (typeof window === "undefined") return;
  if (enabled) {
    localStorage.setItem(CLIENT_NAV_GUARD_V1_TRAIN_STORAGE_KEY, "1");
  } else {
    localStorage.removeItem(CLIENT_NAV_GUARD_V1_TRAIN_STORAGE_KEY);
  }
  window.dispatchEvent(new CustomEvent(NAV_DEBUG_FLAGS_CHANGED_EVENT));
}

export function readClientNavGuardV1NutritionFlag(): boolean {
  if (typeof window === "undefined") return false;
  return localStorage.getItem(CLIENT_NAV_GUARD_V1_NUTRITION_STORAGE_KEY) === "1";
}

export function writeClientNavGuardV1NutritionFlag(enabled: boolean): void {
  if (typeof window === "undefined") return;
  if (enabled) {
    localStorage.setItem(CLIENT_NAV_GUARD_V1_NUTRITION_STORAGE_KEY, "1");
  } else {
    localStorage.removeItem(CLIENT_NAV_GUARD_V1_NUTRITION_STORAGE_KEY);
  }
  window.dispatchEvent(new CustomEvent(NAV_DEBUG_FLAGS_CHANGED_EVENT));
}

export function readClientNavGuardV1SettingsFlag(): boolean {
  if (typeof window === "undefined") return false;
  return localStorage.getItem(CLIENT_NAV_GUARD_V1_SETTINGS_STORAGE_KEY) === "1";
}

export function writeClientNavGuardV1SettingsFlag(enabled: boolean): void {
  if (typeof window === "undefined") return;
  if (enabled) {
    localStorage.setItem(CLIENT_NAV_GUARD_V1_SETTINGS_STORAGE_KEY, "1");
  } else {
    localStorage.removeItem(CLIENT_NAV_GUARD_V1_SETTINGS_STORAGE_KEY);
  }
  window.dispatchEvent(new CustomEvent(NAV_DEBUG_FLAGS_CHANGED_EVENT));
}

export function readClientNavGuardV1WorkoutFlag(): boolean {
  if (typeof window === "undefined") return false;
  return localStorage.getItem(CLIENT_NAV_GUARD_V1_WORKOUT_STORAGE_KEY) === "1";
}

export function writeClientNavGuardV1WorkoutFlag(enabled: boolean): void {
  if (typeof window === "undefined") return;
  if (enabled) {
    localStorage.setItem(CLIENT_NAV_GUARD_V1_WORKOUT_STORAGE_KEY, "1");
  } else {
    localStorage.removeItem(CLIENT_NAV_GUARD_V1_WORKOUT_STORAGE_KEY);
  }
  window.dispatchEvent(new CustomEvent(NAV_DEBUG_FLAGS_CHANGED_EVENT));
}

export function readClientNavGuardV1ExerciseWorkoutFlag(): boolean {
  if (typeof window === "undefined") return false;
  return localStorage.getItem(CLIENT_NAV_GUARD_V1_EXERCISE_WORKOUT_STORAGE_KEY) === "1";
}

export function writeClientNavGuardV1ExerciseWorkoutFlag(enabled: boolean): void {
  if (typeof window === "undefined") return;
  if (enabled) {
    localStorage.setItem(CLIENT_NAV_GUARD_V1_EXERCISE_WORKOUT_STORAGE_KEY, "1");
  } else {
    localStorage.removeItem(CLIENT_NAV_GUARD_V1_EXERCISE_WORKOUT_STORAGE_KEY);
  }
  window.dispatchEvent(new CustomEvent(NAV_DEBUG_FLAGS_CHANGED_EVENT));
}

export function readClientNavGuardV1SecondaryFlag(): boolean {
  if (typeof window === "undefined") return true;
  return localStorage.getItem(CLIENT_NAV_GUARD_V1_SECONDARY_STORAGE_KEY) !== "0";
}

export function writeClientNavGuardV1SecondaryFlag(enabled: boolean): void {
  if (typeof window === "undefined") return;
  if (enabled) {
    localStorage.setItem(CLIENT_NAV_GUARD_V1_SECONDARY_STORAGE_KEY, "1");
  } else {
    localStorage.setItem(CLIENT_NAV_GUARD_V1_SECONDARY_STORAGE_KEY, "0");
  }
  window.dispatchEvent(new CustomEvent(NAV_DEBUG_FLAGS_CHANGED_EVENT));
}

export function readClientNativeBackNavigationFlag(): boolean {
  if (typeof window === "undefined") return false;
  return localStorage.getItem(CLIENT_NATIVE_BACK_NAVIGATION_STORAGE_KEY) === "1";
}

export function writeClientNativeBackNavigationFlag(enabled: boolean): void {
  if (typeof window === "undefined") return;
  if (enabled) {
    localStorage.setItem(CLIENT_NATIVE_BACK_NAVIGATION_STORAGE_KEY, "1");
  } else {
    localStorage.removeItem(CLIENT_NATIVE_BACK_NAVIGATION_STORAGE_KEY);
  }
  window.dispatchEvent(new CustomEvent(NAV_DEBUG_FLAGS_CHANGED_EVENT));
}

export function readClientSectionTabSwipeNavigationFlag(): boolean {
  if (typeof window === "undefined") return false;
  return localStorage.getItem(CLIENT_SECTION_TAB_SWIPE_NAVIGATION_STORAGE_KEY) === "1";
}

export function writeClientSectionTabSwipeNavigationFlag(enabled: boolean): void {
  if (typeof window === "undefined") return;
  if (enabled) {
    localStorage.setItem(CLIENT_SECTION_TAB_SWIPE_NAVIGATION_STORAGE_KEY, "1");
  } else {
    localStorage.removeItem(CLIENT_SECTION_TAB_SWIPE_NAVIGATION_STORAGE_KEY);
  }
  window.dispatchEvent(new CustomEvent(NAV_DEBUG_FLAGS_CHANGED_EVENT));
}

export function readClientProgramSelectorScrollRevealFlag(): boolean {
  if (typeof window === "undefined") return false;
  return localStorage.getItem(CLIENT_PROGRAM_SELECTOR_SCROLL_REVEAL_STORAGE_KEY) === "1";
}

export function writeClientProgramSelectorScrollRevealFlag(enabled: boolean): void {
  if (typeof window === "undefined") return;
  if (enabled) {
    localStorage.setItem(CLIENT_PROGRAM_SELECTOR_SCROLL_REVEAL_STORAGE_KEY, "1");
  } else {
    localStorage.removeItem(CLIENT_PROGRAM_SELECTOR_SCROLL_REVEAL_STORAGE_KEY);
  }
  window.dispatchEvent(new CustomEvent(NAV_DEBUG_FLAGS_CHANGED_EVENT));
}
